// app/javascript/initStartConversation.js

import consumer from "../channels/consumer"

function initMessages(container) {
    const currentUserId = container.dataset.currentUserId

    const applyClassOn = (msg) => {

        const userId = msg.dataset.userId
        console.log("applyClassOn", { userId, currentUserId })
        if (userId === currentUserId) {
            msg.classList.add("message--sent")
            msg.classList.remove("message--received")
        } else {
            msg.classList.add("message--received")
            msg.classList.remove("message--sent")
        }
        const deleteBtn = msg.querySelector('[data-action="delete-message"]');
        if (deleteBtn) {
            deleteBtn.addEventListener("click", async (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                const messageId = deleteBtn.dataset.messageId;
                const juniorId = deleteBtn.dataset.juniorId;
                const discussionId = container.dataset.discussionId;
                const msg = deleteBtn.closest(".message");

                msg.classList.add("message--deleting");

                try {
                    const res = await fetch(`/juniors/${juniorId}/discussions/${discussionId}/messages/${messageId}`, {
                        method: "DELETE",
                        headers: {
                            "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
                            "Accept": "application/json"
                        }
                    });

                    if (!res.ok) {
                        console.error("Erreur lors de la suppression du message");
                        msg.classList.remove("message--deleting");
                        return;
                    }

                    setTimeout(() => {
                        msg.remove();
                    }, 300);

                } catch (err) {
                    msg.classList.remove("message--deleting");
                    console.error("Erreur réseau :", err);
                }
            }, { once: true });

        }
        const isMembre = container.dataset.currentUserIsMembre === "true"

        if (deleteBtn && !isMembre) {
            deleteBtn.style.display = "none"
        }
        const editBtn = msg.querySelector('[data-action="edit-message"]');
        const isOwnMessage = msg.dataset.userId === currentUserId;

        if (editBtn) {
            if (!isOwnMessage || !isMembre) {
                editBtn.style.display = "none";
                return;
            }
            editBtn.addEventListener("click", () => {
                const contentElement = msg.querySelector(".message__bubble-content");
                if (!contentElement) return;

                const originalText = contentElement.innerText.trim(); // ✅ récupération propre
                const textarea = document.createElement("textarea");
                textarea.className = "message__edit-textarea";
                textarea.value = originalText;

                const buttonGroup = document.createElement("div");
                buttonGroup.className = "message__edit-buttons";

                const cancelBtn = document.createElement("button");
                cancelBtn.textContent = "Annuler";
                cancelBtn.className = "btn-cancel";

                const saveBtn = document.createElement("button");
                saveBtn.textContent = "Modifier";
                saveBtn.className = "btn-save";

                buttonGroup.appendChild(cancelBtn);
                buttonGroup.appendChild(saveBtn);

                contentElement.style.display = "none";

                const bubble = msg.querySelector(".message__bubble");
                console.log(bubble)
                bubble.insertBefore(textarea, contentElement.nextSibling);
                bubble.appendChild(buttonGroup);

                const chatForm = document.querySelector(".chat-form");
                if (chatForm) chatForm.style.display = "none";

                cancelBtn.addEventListener("click", () => {
                    textarea.remove();
                    buttonGroup.remove();
                    contentElement.style.display = "";
                    if (chatForm) chatForm.style.display = "";
                });

                saveBtn.addEventListener("click", async () => {
                    const updatedContent = textarea.value.trim();
                    const messageId = editBtn.dataset.messageId;
                    const juniorId = editBtn.dataset.juniorId;
                    const discussionId = container.dataset.discussionId;

                    const res = await fetch(`/juniors/${juniorId}/discussions/${discussionId}/messages/${messageId}`, {
                        method: "PATCH",
                        headers: {
                            "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ content: updatedContent })
                    });

                    if (res.ok) {
                        textarea.remove();
                        buttonGroup.remove();
                        contentElement.style.display = "";
                        if (chatForm) chatForm.style.display = "";
                    } else {
                        alert("Erreur lors de la modification");
                    }
                });
            }, { once: true });

        }


    }

    container.querySelectorAll(".message").forEach(applyClassOn)

    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return
                if (node.matches(".message")) applyClassOn(node)
                node.querySelectorAll?.(".message").forEach(applyClassOn)
            })
        })
    }).observe(container, { childList: true })
}

function subscribeToDiscussion(container) {
    console.log("subscribeToDiscussion", { container })
    const discussionId = container.dataset.discussionId
    const juniorId = container.dataset.juniorId
    console.log("subscribeToDiscussion", { discussionId, juniorId })
    return consumer.subscriptions.create(
        { channel: "DiscussionChannel", discussion_id: discussionId },
        {
            connected() {
                markDiscussionAsRead(juniorId, discussionId)
                console.log(`🔗 Connected to DiscussionChannel ${discussionId}`)
            },
            disconnected() {
                console.log(`🔌 Disconnected from DiscussionChannel ${discussionId}`)
            },
            received(data) {
                console.log("📡 Message reçu :", data);
                if (data.delete) {
                    const messageId = data.delete.message_id;
                    const messageElement = document.querySelector(`[data-message-id="${messageId}"]`);
                    if (messageElement) {
                        messageElement.classList.add("fade-out");
                        setTimeout(() => messageElement.remove(), 300);
                    }
                }
                if (data.update) {
                    const { message_id, content } = data.update;
                    const messageElement = document.querySelector(`[data-message-id="${message_id}"]`);
                    if (messageElement) {
                        const bubble = messageElement.querySelector(".message__bubble-content");
                        if (bubble) {
                            bubble.textContent = content;

                            messageElement.classList.add("message-updated");
                            setTimeout(() => {
                                messageElement.classList.remove("message-updated");
                            }, 1000);
                        }
                    }
                }

                if (data.html) {
                    const container = document.getElementById("messages");
                    container.insertAdjacentHTML("beforeend", data.html);
                    container.scrollTop = container.scrollHeight;
                    markDiscussionAsRead(juniorId, discussionId);
                }

            }

        }
    )
}
function markDiscussionAsRead(juniorId, discussionId) {
    console.log("markDiscussionAsRead", { juniorId, discussionId })
    fetch(`/juniors/${juniorId}/discussions/${discussionId}/mark_as_read`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')

        }
    }).catch(err => console.error("Erreur mark as read :", err));
}


const initStartConversation = () => {
    const openBtn = document.getElementById("open-chat")
    const modal   = document.getElementById("chat-modal")
    const wrapper = modal?.querySelector(".chat-modal__wrapper")

    if (!openBtn || !modal || !wrapper) return
    
    // Éviter la réinitialisation multiple
    if (openBtn.dataset.initialized) return;
    openBtn.dataset.initialized = 'true';

    const discussionId = wrapper.dataset.discussion_id
    const juniorId = wrapper.dataset.junior_id
    openBtn.addEventListener("click", async () => {
        try {
            const res = await fetch(`/juniors/${juniorId}/discussions/${discussionId}?modal=true`, {
                headers: { Accept: "text/html" }
            })
            if (!res.ok) throw new Error("Network error")
            wrapper.innerHTML = await res.text()
            modal.classList.remove("hidden")

            const container = wrapper.querySelector("#messages")
            if (!container) return

            initMessages(container)

            container.scrollTop = container.scrollHeight

            subscribeToDiscussion(container)

            const chatForm = wrapper.querySelector(".chat-form")
            if (chatForm) {
                const textarea = chatForm.querySelector("textarea")
                textarea.addEventListener("keydown", e => {
                    if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault()
                        chatForm.requestSubmit()
                    }
                })
                chatForm.addEventListener("turbo:submit-end", () => {
                    chatForm.reset()
                })
            }

            wrapper
                .querySelector(".chat-modal__close")
                ?.addEventListener("click", () => {
                    modal.classList.add("hidden")
                    wrapper.innerHTML = ""
                })

            modal.addEventListener("click", e => {
                if (e.target === modal) {
                    modal.classList.add("hidden")
                    wrapper.innerHTML = ""
                }
            })
        } catch (err) {
            console.error("Impossible de charger la discussion :", err)
        }
    })
}

export { initStartConversation }
